import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './MillingServices.css';

const MillingServices = () => {
    const [activeFaq, setActiveFaq] = useState(0);
    const navigate = useNavigate();
    const goToContact = () => navigate('/contact', { state: { scrollToForm: true } });

    const faqs = [
        {
            q: "What types of milling operations do you provide?",
            a: "We provide surface milling, slot milling, face milling, and profile milling based on client requirements."
        },
        {
            q: "Can you handle complex component geometries?",
            a: "Yes, we specialize in precision milling for complex shapes and tight tolerance components."
        },
        {
            q: "Do you support bulk production?",
            a: "Yes, we handle both small batch and high-volume milling production."
        }
    ];

    return (
        <div className="milling-services-page">
            {/* Hero Section */}
            <section className="milling-hero">
                <div className="container">
                    <h1 className="fade-in">Precision Milling Services</h1>
                </div>
            </section>

            {/* About Section */}
            <section className="milling-about-section section-padding">
                <div className="container">

                    <div className="milling-about-header">
                        <div className="milling-about-title-group">
                            <div className="milling-icon-wrapper">
                                <img src="https://sakthivel.ascentbw.com/Files/About/About4.png" alt="Milling Icon" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/About/About1.png"; }} />
                            </div>
                            <h2>About Our Milling Services</h2>
                        </div>

                        <div className="milling-about-header-split">
                            <div className="milling-about-header-text">
                                <p>Sakthivel Engineering provides precision milling services for a wide range of industrial metal components. Our advanced milling machines ensure accurate shaping, slotting, contouring, and surface finishing for both prototype development and large-scale production.</p>
                            </div>
                            <div className="milling-about-header-btn">
                                <button className="btn-primary" onClick={goToContact}>Request a Quote</button>
                            </div>
                        </div>
                    </div>

                    <div className="milling-capabilities-group">
                        <div className="milling-capability-block">
                            <h3>Our Milling Capabilities</h3>
                            <p>We deliver reliable milling solutions tailored to your technical drawings and machining requirements.</p>
                            <p className="mt-20">Our capabilities include:</p>
                            <ul className="milling-capabilities-list mt-10">
                                <li>• Surface Milling</li>
                                <li>• Slot Milling</li>
                                <li>• Face Milling</li>
                                <li>• Profile Milling</li>
                                <li>• Keyway Cutting</li>
                                <li>• Prototype & Bulk Production</li>
                            </ul>
                        </div>

                        <div className="milling-capability-block mt-40">
                            <h3>Our Milling Services Include</h3>
                            <p>We offer customized milling solutions designed to meet complex component geometries and dimensional requirements across industrial sectors.</p>
                        </div>
                    </div>

                    <div className="milling-about-img mt-40">
                        <img src="https://sakthivel.ascentbw.com/Files/Service/Sub4.png" alt="Milling Process" onError={(e) => { e.target.onerror = null; e.target.src = "https://sakthivel.ascentbw.com/Files/Service/Sub1.png"; }} />
                    </div>

                    <div className="milling-quality-block mt-40">
                        <h3>Quality & Process Control</h3>
                        <p className="mt-20">At Sakthivel Engineering, we follow strict quality procedures to ensure consistent milling accuracy and surface finish.</p>
                        <ul className="milling-quality-list mt-20">
                            <li>Dimensional verification</li>
                            <li>Surface roughness inspection</li>
                            <li>Tolerance adherence monitoring</li>
                        </ul>
                    </div>

                </div>
            </section>

            {/* Process Section */}
            <section className="milling-process-section section-padding bg-light">
                <div className="container">
                    <h2 className="section-title text-center mb-50">Our Milling Process</h2>

                    <div className="process-grid">
                        <div className="process-card">
                            <div className="process-num">01</div>
                            <h5 className="process-accent">Requirement Review</h5>
                            <h4>Drawing Review &<br />Planning</h4>
                            <p>We analyze technical drawings, component geometry, tolerances, and machining feasibility before production.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">02</div>
                            <h5 className="process-accent">Machining Process</h5>
                            <h4>Precision Milling<br />Execution</h4>
                            <p>Using calibrated milling machines, we perform accurate shaping, cutting, and finishing operations to meet dimensional specifications.</p>
                        </div>
                        <div className="process-card">
                            <div className="process-num">03</div>
                            <h5 className="process-accent">Quality & Delivery</h5>
                            <h4>Inspection &<br />Delivery</h4>
                            <p>Each milled component undergoes thorough inspection before secure packaging and on-time delivery.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ & Split Section */}
            <section className="milling-faq-section section-padding bg-light pt-0">
                <div className="container">
                    <div className="milling-faq-split">

                        <div className="milling-faq-left">
                            <h5 className="faq-accent">FAQ</h5>
                            <h2 className="section-title text-left">Frequently Asked<br />Questions</h2>
                            <p>Find answers to common questions about our milling services, capabilities, and production process.</p>
                            <button className="btn-primary mt-30" onClick={goToContact}>Request a Quote</button>
                        </div>

                        <div className="milling-faq-right">
                            <div className="milling-faq-grid">
                                {faqs.map((faq, idx) => (
                                    <div
                                        key={idx}
                                        className={`milling-faq-item ${activeFaq === idx ? 'active' : ''}`}
                                        onClick={() => setActiveFaq(activeFaq === idx ? null : idx)}
                                    >
                                        <div className="milling-faq-header">
                                            <h4>{faq.q}</h4>
                                            <span className="toggle-icon1"></span>
                                        </div>
                                        <div className="milling-faq-body">
                                            <p>{faq.a}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="milling-cta-section">
                <div className="container text-center">
                    <h2>Need Professional Milling<br />Services?</h2>
                    <p>Share your component drawings and specifications. Our team will provide a competitive<br />quotation with accurate production timelines.</p>
                    <button className="btn-light mt-30" onClick={goToContact}>Request a Milling Quote</button>
                </div>
            </section>
        </div>
    );
};

export default MillingServices;
